import React from 'react';
import { useApp } from '../context/AppContext';

// A thin bar across the top when the server is serving a newer build than this
// tab is running.
//
// Deploys land several times a day, and a page left open — a laptop tab from
// yesterday, a phone in a pocket — keeps running the code it loaded. The
// buttons a deploy added are not on that screen at all, so tapping where they
// should be does nothing, which reads as the app being broken rather than old.
//
// It never reloads on its own. Somebody halfway through writing an estimate
// must not have the page pulled out from under them; the offer sits there
// until they take it.
export default function UpdateBar() {
  const { newBuild } = useApp();
  if (!newBuild) return null;

  return (
    <div
      role="status"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 501,
        background: 'var(--blue)', color: 'white',
        fontSize: 12.5, textAlign: 'center', padding: '7px 12px',
        letterSpacing: '.02em', display: 'flex', gap: 12,
        alignItems: 'center', justifyContent: 'center',
      }}
    >
      A newer version of the app is available.
      <button
        onClick={() => window.location.reload()}
        style={{
          background: 'white', color: 'var(--blue)', border: 'none',
          borderRadius: 50, padding: '3px 12px', fontFamily: 'inherit',
          fontSize: 12.5, cursor: 'pointer',
        }}
      >
        Reload
      </button>
    </div>
  );
}
